import { Logger } from '@anm/helpers/Debugger';

const authLogger = new Logger('AuthLogger');

export default authLogger;
